import { TableBody, TableCell, TableRow, Typography } from "@mui/material";

export default function InlineText(props) {
  let { tag, value, alt, divider, ...other } = props;
  alt = alt ?? "-";

  let sx = {
    maxWidth: "max-content",
    ...(other?.sx ?? {}),
  };

  if (!divider) divider = ":";

  return (
    <TableRow sx={{ mt: 1 }}>
      <TableCell sx={{ p: "5px" }}>
        <Typography
          paragraph
          sx={{ color: "text.disabled", p: 0, m: 0 }}
          variant="subtitle2"
        >
          {tag}
        </Typography>
      </TableCell>

      {divider && <TableCell sx={{ p: 0, pl: 1, pr: 2 }}>{divider}</TableCell>}

      <TableCell sx={{ p: 0 }}>
        <Typography {...other} sx={sx}>
          {value && value !== undefined && value !== "" && value !== null
            ? value
            : alt}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export function InlineTextContainer(props) {
  let { children } = props;
  return <TableBody>{children}</TableBody>;
}
